"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_slick_1 = __importDefault(require("react-slick"));
const react_uid_1 = require("react-uid");
const decorators_1 = require("../../../../common/decorators");
const Slide_1 = __importDefault(require("./Slide"));
const Controller_1 = __importDefault(require("./Controller"));
const TIME_UNTIL_FIRST_ITEM_IS_TRANSITIONED = 10;
const Carousel = ({ slides, updateStore, isCarouselPaused }) => {
    var _a, _b, _c;
    const [progress, setProgress] = (0, react_1.useState)(0);
    let sliderRef = (0, react_1.useRef)(null);
    const currentSlide = ((_c = (_b = (_a = sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) === null || _a === void 0 ? void 0 : _a.innerSlider) === null || _b === void 0 ? void 0 : _b.state) === null || _c === void 0 ? void 0 : _c.currentSlide) || 0;
    const totalSlides = slides.length;
    (0, react_1.useEffect)(() => {
        let interval;
        if (!isCarouselPaused) {
            interval = setInterval(() => {
                setProgress(prev => prev + 1);
            }, (TIME_UNTIL_FIRST_ITEM_IS_TRANSITIONED * 1000) / 100);
        }
        return () => clearInterval(interval);
    }, [isCarouselPaused]);
    const goToSlide = index => {
        var _a;
        if (!sliderRef.current)
            return;
        (_a = sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) === null || _a === void 0 ? void 0 : _a.slickGoTo(index);
    };
    const beforeSlideChange = (oldIndex, newIndex) => {
        // Buggy slick will not call afterChange because during the wait period resizeWindow is being called and it clears the timeout
        // https://github.com/akiran/react-slick/issues/1262
        const carouselIsAboutToRestart = newIndex === 0 && oldIndex === slides.length - 1;
        const singleItem = newIndex === oldIndex;
        const slideContent = slides[newIndex];
        setTimeout(() => {
            try {
                if (!slideContent) {
                    console.warn(`Slide at index ${newIndex} is undefined.`);
                    return;
                }
                setProgress(0);
                updateStore('activeItem', {
                    content: slideContent,
                    type: slideContent.type,
                });
                if (carouselIsAboutToRestart && !singleItem) {
                    updateStore('reloadNeeded', true);
                    return;
                }
            }
            catch (err) {
                console.error('Error in beforeSlideChange timeout:', err);
            }
        }, 100);
    };
    const settings = {
        infinite: true,
        fade: true,
        lazyLoad: 'progressive',
        touchThreshold: 100,
        arrows: false,
        dots: true,
        draggable: false,
        autoplay: false,
        beforeChange: (oldIndex, newIndex) => beforeSlideChange(oldIndex, newIndex),
        appendDots: () => react_1.default.createElement(Controller_1.default, { goToSlide: goToSlide, currentSlide: currentSlide, progress: progress }),
    };
    const carouselData = slides.map(slide => react_1.default.createElement(Slide_1.default, { key: (0, react_uid_1.uid)(slide), content: slide }));
    return (react_1.default.createElement(react_slick_1.default, Object.assign({ ref: sliderRef }, settings, { className: "slider-wrapper" }), carouselData));
};
const mapStoreToProps = store => ({
    slides: store.getValue('slides'),
    isCarouselPaused: store.getValue('isCarouselPaused'),
});
exports.default = (0, decorators_1.withStore)(mapStoreToProps)(Carousel);
